import { Link } from 'react-router-dom';
import { IconInbox } from './icons';

/**
 * Card-level "nothing here yet" state - icon + message + optional CTA.
 * `to` renders the action as a router Link, `onClick` as a button - pass
 * at most one.
 */
function EmptyState({ icon, message, ctaLabel, to, onClick }) {
  const Icon = icon || IconInbox;
  return (
    <div className="dash-empty-state">
      <div className="dash-empty-state-icon">
        <Icon size={22} />
      </div>
      <p className="dash-empty-state-message">{message}</p>
      {ctaLabel && to && (
        <Link to={to} className="dash-btn dash-btn-orange dash-empty-state-cta">
          {ctaLabel}
        </Link>
      )}
      {ctaLabel && onClick && !to && (
        <button type="button" className="dash-btn dash-btn-orange dash-empty-state-cta" onClick={onClick}>
          {ctaLabel}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
